import apiClient from './api';

export const therapyPackageService = {
	getAll: async () => {
		const res = await apiClient.get('/TherapyPackages');
		return res.data;
	},
	create: async (payload) => {
		const res = await apiClient.post('/TherapyPackages', payload);
		return res.data;
	},
	getById: async (id) => {
		const res = await apiClient.get(`/TherapyPackages/${id}`);
		return res.data;
	},
	update: async (id, payload) => {
		const res = await apiClient.put(`/TherapyPackages/${id}`, payload);
		return res.data;
	},
	remove: async (id) => {
		const res = await apiClient.delete(`/TherapyPackages/${id}`);
		return res.data;
	},
	getPopular: async () => {
		const res = await apiClient.get('/TherapyPackages/popular');
		return res.data;
	}
};

